import { observer } from 'mobx-react-lite'
import {
  CheckoutViewMainHeader,
  CheckoutViewMainHeaderBulletList,
  CheckoutViewMainHeaderBulletListItem,
  CheckoutViewMainHeaderContent,
  CheckoutViewMainHeaderTitle,
} from '@/features/jobs/drafting/checkout/components/CheckoutView/index'
import type { DraftJobViewModel } from '@/features/jobs/drafting/DraftJobViewModel'

interface CheckoutViewHeaderContainerProps {
  vm: DraftJobViewModel
}

/**
 * Intro Text Container
 */
export const CheckoutViewHeaderContainer = observer(
  function CheckoutViewHeaderContainer({
    vm,
  }: CheckoutViewHeaderContainerProps) {
    switch (vm.job.legend.serviceType) {
      case 'Tax':
        return <CheckoutViewTaxHeader />
      case 'Consultation':
        return <CheckoutViewConsultationHeader />
      case 'Bookkeeping':
        return <CheckoutViewBookkeepingHeader />
      case 'Misc':
      default:
        return <CheckoutViewMiscHeader />
    }
  },
)

function CheckoutViewTaxHeader() {
  return (
    <CheckoutViewMainHeader>
      <CheckoutViewMainHeaderTitle>
        Your stress-free tax filing starts here
      </CheckoutViewMainHeaderTitle>
      <CheckoutViewMainHeaderContent>
        <CheckoutViewMainHeaderBulletList>
          <CheckoutViewMainHeaderBulletListItem>
            Complete tax preparation by licensed CPAs and EAs
          </CheckoutViewMainHeaderBulletListItem>
          <CheckoutViewMainHeaderBulletListItem>
            Your Pro handles everything from start to filed return
          </CheckoutViewMainHeaderBulletListItem>
          <CheckoutViewMainHeaderBulletListItem>
            Every deduction and credit captured for maximum refund
          </CheckoutViewMainHeaderBulletListItem>
        </CheckoutViewMainHeaderBulletList>
      </CheckoutViewMainHeaderContent>
    </CheckoutViewMainHeader>
  )
}

function CheckoutViewConsultationHeader() {
  return (
    <CheckoutViewMainHeader>
      <CheckoutViewMainHeaderTitle>
        Expert tax advice, tailored to you
      </CheckoutViewMainHeaderTitle>
      <CheckoutViewMainHeaderContent>
        <CheckoutViewMainHeaderBulletList>
          <CheckoutViewMainHeaderBulletListItem>
            One on one video call with a tax professional
          </CheckoutViewMainHeaderBulletListItem>
          <CheckoutViewMainHeaderBulletListItem>
            Tax advice tailored to your unique situation
          </CheckoutViewMainHeaderBulletListItem>
          <CheckoutViewMainHeaderBulletListItem>
            Get actionable strategies to reduce future tax liability
          </CheckoutViewMainHeaderBulletListItem>
        </CheckoutViewMainHeaderBulletList>
      </CheckoutViewMainHeaderContent>
    </CheckoutViewMainHeader>
  )
}

function CheckoutViewBookkeepingHeader() {
  return (
    <CheckoutViewMainHeader>
      <CheckoutViewMainHeaderTitle>
        Professional bookkeeping made simple
      </CheckoutViewMainHeaderTitle>
      <CheckoutViewMainHeaderContent>
        <CheckoutViewMainHeaderBulletList>
          <CheckoutViewMainHeaderBulletListItem>
            Stay organized with monthly financial statements
          </CheckoutViewMainHeaderBulletListItem>
          <CheckoutViewMainHeaderBulletListItem>
            Tax-ready books throughout the year
          </CheckoutViewMainHeaderBulletListItem>
          <CheckoutViewMainHeaderBulletListItem>
            Expert support from certified bookkeepers
          </CheckoutViewMainHeaderBulletListItem>
        </CheckoutViewMainHeaderBulletList>
      </CheckoutViewMainHeaderContent>
    </CheckoutViewMainHeader>
  )
}

function CheckoutViewMiscHeader() {
  return (
    <CheckoutViewMainHeader>
      <CheckoutViewMainHeaderTitle>
        Enjoy simplified accounting services
      </CheckoutViewMainHeaderTitle>
      <CheckoutViewMainHeaderContent>
        <CheckoutViewMainHeaderBulletList>
          <CheckoutViewMainHeaderBulletListItem>
            Expert assistance from licensed professionals
          </CheckoutViewMainHeaderBulletListItem>
          <CheckoutViewMainHeaderBulletListItem>
            Tailored solutions for your specific needs
          </CheckoutViewMainHeaderBulletListItem>
          <CheckoutViewMainHeaderBulletListItem>
            Secure and confidential handling guaranteed
          </CheckoutViewMainHeaderBulletListItem>
        </CheckoutViewMainHeaderBulletList>
      </CheckoutViewMainHeaderContent>
    </CheckoutViewMainHeader>
  )
}
